import React from 'react';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="bg-white min-h-screen text-gray-800">
      <div className="max-w-6xl mx-auto px-4 py-16 md:py-24">
        
        {/* Header Section */}
        <div className="text-center mb-12 -mt-6 md:-mt-10">
          <h1 className="text-3xl md:text-5xl font-serif font-bold text-[#334a21] mb-4">
            Privacy Policy
          </h1>
          <p className="text-gray-500 text-sm md:text-base">
            Last Updated: December 17, 2025
          </p>
         <div className="h-1 w-20 bg-[#334a21] mx-auto mt-3 rounded-full opacity-20"></div>

        </div>

        {/* Content Section */}
        <div className="space-y-8 leading-relaxed text-gray-700">
          
          <section>
            <h2 className="text-xl md:text-2xl font-bold text-[#334a21] mb-3">1. Introduction</h2>
            <p>
              Welcome to <strong>AyushVatika</strong>. We value your trust and are committed to protecting your personal information. This Privacy Policy outlines how we collect, use, and safeguard your data when you visit our website or purchase our herbal products.
            </p>
          </section>

          <section>
            <h2 className="text-xl md:text-2xl font-bold text-[#334a21] mb-3">2. Information We Collect</h2>
            <p className="mb-2">We may collect the following types of information:</p>
            <ul className="list-disc list-inside space-y-2 ml-2">
              <li><strong>Personal Information:</strong> Name, email address, phone number, and shipping address when you place an order.</li>
              <li><strong>Payment Information:</strong> We do not store your credit card details. All transactions are processed through secure payment gateways.</li>
              <li><strong>Usage Data:</strong> Information on how you access and use our website (e.g., pages visited, time spent).</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl md:text-2xl font-bold text-[#334a21] mb-3">3. How We Use Your Information</h2>
            <p>Your data helps us to:</p>
            <ul className="list-disc list-inside space-y-2 ml-2 mt-2">
              <li>Process and deliver your orders efficiently.</li>
              <li>Send you updates regarding your order status.</li>
              <li>Improve our website functionality and customer service.</li>
              <li>Send promotional emails about new herbal products (only if you opt-in).</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl md:text-2xl font-bold text-[#334a21] mb-3">4. Cookies</h2>
            <p>
              We use cookies to enhance your browsing experience. Cookies help us remember your preferences and cart items. You can choose to disable cookies through your browser settings, but this may affect some site features.
            </p>
          </section>

          <section>
            <h2 className="text-xl md:text-2xl font-bold text-[#334a21] mb-3">5. Data Sharing</h2>
            <p>
              We do not sell or rent your personal information to third parties. We may share data with trusted service providers (e.g., shipping partners like courier services) solely for the purpose of fulfilling your orders.
            </p>
          </section>

          <section>
            <h2 className="text-xl md:text-2xl font-bold text-[#334a21] mb-3">6. Contact Us</h2>
            <p>
              If you have any questions about this Privacy Policy, please contact us at:
            </p>
            <p className="mt-2 font-medium text-[#334a21]">
              Email: support@ayushvatika.com<br />
              Phone: +91 9412220200
            </p>
          </section>

        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;